import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    base: '/gyeongridan/',
    mode: 'history',
    routes: [
        require('./views/about').default,
        require('./views/coupon').default,
        require('./views/map').default,
        require('./views/program').default,
        require('./views/programs').default,
        require('./views/spot').default,

        // require('./views/admin').default
    ],
    scrollBehavior(to, fr, saved) {
        return saved ? saved : { x: 0, y: 0 }
    }
})
